import { tokenUser,removeBind,weixinBind ,weixinRegister} from '@/api/weixin'
import { addCompany ,editCompany} from '@/api/company'
import { setPerosnCustomer,editUser,joinCompany ,changeCompany,quitCompany,noticeStatus,readNotice,registerCompany,inviteCompany} from '@/api/user'



import { getUserToken, setUserToken,removeUserToken} from '@/store/cookie'
import { getWxConfigId, setWxConfigId } from '@/store/cookie'
import { getScanUrl, setScanUrl, removeScanUrl } from '@/store/cookie'

const user = {

  state: {
    user_detail:{},
    time:'',
    servicer_search_record:[],
    user_notice_status:1,
    create_order_cache:1,
    last_order_cache: {servicer_company_id: 0},
    trouble_describe_record: [],
  },

  mutations: {

    SET_USER_TOKEN: (state, user_token) => {
      state.time = Date.parse(new Date())
      if(!user_token || user_token==''){
        removeUserToken()
      }else{
         setUserToken(user_token)
      }
    },

    SET_USER_DETAIL: (state, user_detail) => {
      state.user_detail = user_detail
    },

    SET_SCAN_URL: (state, scan_url) => {
       state.time = Date.parse(new Date())
      if(!scan_url || scan_url==''){
        removeScanUrl()
      }else{
        setScanUrl(scan_url)
      }
    },

    SET_SERVICER_SEARCH_RECORD: (state,search_record) => {
      state.time = Date.parse(new Date())
      state.servicer_search_record = search_record
    },

    SET_USER_NOTICE_STATUS:(state,status) => {
      state.user_notice_status = status
    },

    SET_CREATE_ORDER_CACHE: (state, flag) => {
      state.create_order_cache = flag
    },

    SET_LAST_ORDER_CACHE: (state, data) => {
      state.last_order_cache = data
    },

    SET_TROUBLE_DESCRIBE_RECORD: (state, data) => {
      state.trouble_describe_record = data
    }

  },

  actions: {

    // 绑定
    WeixinBind({ commit ,state}, userInfo) {
      //如果有二维码 追加二维码信息
      if(getScanUrl()){
          userInfo.scan_url = getScanUrl()
      }
      return new Promise((resolve, reject) => {
        weixinBind(userInfo).then(response => {
          if(response.code != 0){
             reject(response)
          }
          if(response.data){
             let user_detail = response.data
             commit('SET_USER_DETAIL', user_detail)
          }else{
              commit('SET_USER_DETAIL', {})
          }
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

       // 绑定
    WeixinRegister({ commit ,state}, userInfo) {
      //如果有二维码 追加二维码信息
      if(getScanUrl()){
          userInfo.scan_url = getScanUrl()
      }
      return new Promise((resolve, reject) => {
        weixinRegister(userInfo).then(response => {
          if(response.code != 0){
             reject(response)
          }
          if(response.data){
             let user_detail = response.data
             commit('SET_USER_DETAIL', user_detail)
          }else{
              commit('SET_USER_DETAIL', {})
          }
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },



    //获取用户信息
    GetTokenUser({ commit, state },params) {
      return new Promise((resolve, reject) => {
        tokenUser(params).then(response => {
          if(response.code != 0){
             reject(response.msg)
          }
          if(response.data){

             let user_detail = response.data.user_detail
             commit('SET_USER_DETAIL', user_detail)

          }else{
             commit('SET_USER_DETAIL', {})
          }
          resolve(response.data)
        }).catch(error => {
          reject(error)
        })
      })
    },

    RemoveBind({ commit ,state}) {
      return new Promise((resolve, reject) => {
        removeBind({'user_token': getUserToken(),'wx_config':getWxConfigId(),'account_id':state.user_detail.account.account_id}).then( response => {
          if(response.code != 0){
             reject(response)
           }else{
             commit('SET_USER_TOKEN', '')
             commit('SET_USER_DETAIL', '')
             commit('SET_CREATE_ORDER_CACHE',0)
             commit('SET_TROUBLE_DESCRIBE_RECORD',[])
             resolve(response)
           }
        }).catch(error => {
          reject(error)
        })
      })
    },

    SetPerosnCustomer({ commit,state},params){
      return new Promise((resolve, reject) => {
         setPerosnCustomer(params).then(response => {
            if(response.code != 0){
               reject(response)
            }else{
              if(response.data){
                let user_detail = response.data
                commit('SET_USER_DETAIL', user_detail)
              }
            }
            resolve(response)
          }).catch(error => {
            reject(error)
          })
      })
    },

    AddCompany({ commit,state},company){
      return new Promise((resolve, reject) => {
         addCompany(company).then(response => {
            if(response.code != 0){
               reject(response)
            }else{
              if(response.data){
                let user_detail = response.data
                commit('SET_USER_DETAIL', user_detail)
              }
            }
            resolve(response)
          }).catch(error => {
            reject(error)
          })
      })
    },
    RegisterCompany({ commit,state},company){
      return new Promise((resolve, reject) => {
        registerCompany(company).then(response => {
            if(response.code != 0){
               reject(response)
            }else{
              if(response.data){
                let user_detail = response.data
                commit('SET_USER_DETAIL', user_detail)
              }
            }
            resolve(response)
          }).catch(error => {
            reject(error)
          })
      })
    },
    InviteCompany({ commit,state},company){
      return new Promise((resolve, reject) => {
        inviteCompany(company).then(response => {
            if(response.code != 0){
               reject(response)
            }else{
              if(response.data){
                let user_detail = response.data
                commit('SET_USER_DETAIL', user_detail)
              }
            }
            resolve(response)
          }).catch(error => {
            reject(error)
          })
      })
    },
    EditCompany({ commit,state},company){
      return new Promise((resolve, reject) => {
         editCompany(company).then(response => {
            if(response.code != 0){
               reject(response)
            }else{
              if(response.data){
                let user_detail = response.data
                commit('SET_USER_DETAIL', user_detail)
              }
            }
            resolve(response)
          }).catch(error => {
            reject(error)
          })
      })
    },

    JoinCompany({ commit,state},company){
      return new Promise((resolve, reject) => {

         joinCompany(company).then(response => {
            if(response.code != 0){
               reject(response)
            }else{
              if(response.data){
                let user_detail = response.data
                commit('SET_USER_DETAIL', user_detail)
              }
            }
            resolve(response)
          }).catch(error => {
            reject(error)
          })
      })
    },

    ChangeCompany({ commit,state},company){
      return new Promise((resolve, reject) => {
         changeCompany(company).then(response => {

            if(response.code != 0){
               reject(response)
            }else{
              if(response.data && response.data.list){
                //本地将当前公司切换到第一个
                 let user_detailTmp = state.user_detail
                 let companyListTmp =  user_detailTmp.company
                 if(companyListTmp){
                    companyListTmp.forEach((item,subIndex,arr)=>{
                        if(item.company_id == company.change_company_id){
                            companyListTmp[subIndex].is_default = 1
                        }else{
                            companyListTmp[subIndex].is_default = 0
                        }
                    })
                    user_detailTmp.company = companyListTmp
                    commit('SET_USER_DETAIL', user_detailTmp)
                 }

              }
            }
            //清除报修页缓存
            commit('SET_CREATE_ORDER_CACHE',0);
            resolve(response)
          }).catch(error => {
            reject(error)
          })
      })
    },

    //退出公司
    QuitCompany ({ dispatch,commit,state},company){
      //退出的公司从本地缓存中去除
      company.account_id = state.user_detail.account.account_id
      return new Promise((resolve, reject) => {
        quitCompany(company).then(response => {

          if(response.code == 0){
             //退出清空本地登录缓存
             dispatch('RemoveBind')
            //清除报修页缓存
            commit('SET_CREATE_ORDER_CACHE',0);
          }
          resolve(response)
        })
      })

    },

    ChangeCompanyLocal({ commit,state},company){
       //本地将当前公司切换到第一个
       let user_detailTmp = state.user_detail
       let companyListTmp =  user_detailTmp.company
       if(companyListTmp){
          companyListTmp.forEach((item,subIndex,arr)=>{
              if(item.company_id == company.change_company_id){
                  companyListTmp[subIndex].is_default = 1
              }else{
                  companyListTmp[subIndex].is_default = 0
              }
          })
          user_detailTmp.company = companyListTmp
          commit('SET_USER_DETAIL', user_detailTmp)
          //清除报修页缓存
          commit('SET_CREATE_ORDER_CACHE',0);
       }
    },

    EditUser({ commit,state},user){
      return new Promise((resolve, reject) => {
         editUser(user).then(response => {
            if(response.code != 0){
               reject(response)
            }else{
              if(response.data && response.data.user){
                let tmpUser = state.user_detail
                if(user.user_name){
                    tmpUser.user.name = response.data.user.name
                }
                //将user反写到account
                if(user.mobile){
                    tmpUser.account.mobile = response.data.user.mobile
                }
                if(user.sex){
                    tmpUser.user.sex = response.data.user.sex
                }
                if(user.head_img){
                    tmpUser.user.head_img = response.data.user.head_img
                }
                commit('SET_USER_DETAIL', tmpUser)
              }
            }
            resolve(response)
          }).catch(error => {
            reject(error)
          })
      })
    },

    //用户通知状态
    UserNoticeStatus({ commit,state},params){
      noticeStatus(params).then(response => {
          let status = 0
          if(response.data){
            status =  response.data.status
          }
          commit('SET_USER_NOTICE_STATUS', status)
      })
    },

    UserNoticeRead({ dispatch,commit,state},params){
      return new Promise((resolve, reject) => {
        readNotice(params).then(response => {
          //再调用获取已读状态
          dispatch('UserNoticeStatus',params)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    EmptyUserToken({ commit, state }){
      commit('SET_USER_TOKEN', '')
      commit('SET_USER_DETAIL', '')
    },

    EmptyUserDetail({ commit, state }){
      commit('SET_USER_DETAIL', '')
    },
    SetScanUrl({ commit, state },scan_url){
       commit('SET_SCAN_URL', scan_url)
        //清除报修页缓存
        commit('SET_CREATE_ORDER_CACHE',0);
    },

    SetServicerSearchRecord({ commit, state},search_record)
    {
      commit('SET_SERVICER_SEARCH_RECORD',search_record)
    },

    SetCreateOrderCache({ commit, state},flag)
    {
      commit('SET_CREATE_ORDER_CACHE',flag)
    },

    SetLastOrderCache({ commit, state},data)
    {
      commit('SET_LAST_ORDER_CACHE',data)
    },

    SetTroubleDescribeRecord({ commit, state}, data)
    {
      commit('SET_TROUBLE_DESCRIBE_RECORD', data)
    },

  }

}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js